import React  from "react";

const NewsPanel = (props) => {

    return (

        <div className={`h-full flex flex-col rounded-2xl bg-gradient-to-r from-blue-50 to-yellow dark:from-gray-900 dark:to-gray-950 shadow-inner border-2 border-blue-100 p-4 ${props.fontClass || ''}`}>

            <h2 className="font-semibold leading-tight text-dark-blue-400">{props.title}</h2>

            <div className="w-full h-48 mt-4 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
                <img alt="Image for News Panel" className="w-full h-full object-contain" src={props.imageSource} loading="lazy" />
            </div>

            <p className="leading-snug text-gray-400 mt-4 flex-1 font-sans">{props.preview}</p>

            <p dir="rtl" className="mt-4">
                <a href={props.link} className="self-end border-b
                            hover:text-red-700 pb-0.5 hover:border-red-700 border-red-700" target="_blank" rel="noreferrer">More</a>
            </p>
        </div>

    );

}

export default React.memo(NewsPanel);